import { useTranslation } from 'react-i18next';

interface EmptyStateProps {
  message?: string | null;
  className?: string;
}

export function EmptyState({ message, className = '' }: EmptyStateProps) {
  const { t } = useTranslation();

  return (
    <div className={`empty-state ${className}`}>
      <p>{message || t('COMMON.NO_DATA')}</p>
    </div>
  );
}
